// import React from "react";
// import EmployeeBody from "./TableBody/EmployeeBody";
// import EmployeeHead from "./TableHead/EmployeeHead";

// const EmployeeTable = ({
//   permissionsAccessControl,
//   employees,
//   handleDelete,
//   handleResetPass,
//   status,
// }) => {
//   return (
//     <div className="row" style={{ marginTop: "10px" }}>
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table style={{ overflow: "hidden" }}>
//                 <EmployeeHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />
//                 <EmployeeBody
//                   employees={employees}
//                   handleDelete={handleDelete}
//                   handleResetPass={handleResetPass}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmployeeTable;

import React from "react";
import GetEmployeeTableColumns from "./ColumnDefinition/EmployeeColumn/GetEmployeeTableColumns";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapEmployeeToDataTable as mapData } from "./Helper";

const EmployeeTable = ({ data, handleResetPass, handleDelete, status }) => {
  const columns = GetEmployeeTableColumns({
    handleResetPass,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default EmployeeTable;
